import React from 'react';
import {Row, ContenedorForm, HeaderForm, CuerpoForm, TituloForm, ContainerCol } from '../componentes_generales/componentes_formulario/contenedores/';
import { LabelForm } from '../componentes_generales/componentes_formulario/labels/';
import { cargarCatalogosGenericoAsyncInvertido } from '../../funciones_globales/catalogos';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { generar_LogAuditoriaIngresoForm, generar_LogAuditoriaSalidaForm } from '../../actions/generales/act_gen03';
import ReactSelectAsync from '../componentes_generales/componentes_formulario/selects/react-select-async';

import { visualizarReporteEnPdf } from '../../funciones_globales/interaccionApiReportes';

class FormImpor09  extends React.Component{
    constructor(props){
        super(props);
        this.state = {

            importacion_sel: null,
            opcion: null
        };
        //OP OVERCONTROLLS
        this.changeComponents = this.changeComponents.bind(this);
        this.limpiar = this.limpiar.bind(this);
        this.impGastoImportacion = this.impGastoImportacion.bind(this);
    }

    changeComponents(event){

        const target = event.target;       
        const name = target.name; 
        var value = target.type === 'checkbox' ? target.checked : target.value; 

        if(target.type==='checkbox' && name==='opcion'){
            if(value === true){
                value = 'I';
            }else{
                value = 'G';
            }
        }
        this.setState({[name]: value});
    }

    getOptions_Importaciones(input, callback){
        if (input.toString().length >= 3 ){
            let cadena_busq = '?cadena_busq=' + input;
            cargarCatalogosGenericoAsyncInvertido('/importaciones', cadena_busq, callback)  
        }
    }

    componentDidMount(){
        this.props.generar_LogAuditoriaIngresoForm('0309')
    }

    componentWillUnmount(){
        this.props.generar_LogAuditoriaSalidaForm('0309');
    }

    limpiar(){
        //Asignacion de Fecha
        this.setState({importacion_sel: null, opcion: null})
    }

    impGastoImportacion(){
        var parametros = "";
        parametros = '&rpt=51&param1='+this.state.importacion_sel.value
        if(this.state.opcion!==null){
            parametros = parametros+'&param2='+this.state.opcion
        }
        visualizarReporteEnPdf(parametros);
    }

    render(){
        return (
            <ContenedorForm porc_ancho={60}>
            <HeaderForm>
                <TituloForm>Gasto de Importación</TituloForm>
            </HeaderForm>
            <CuerpoForm>                
                <Row>
                    <ContainerCol className='col-sm-2' margen_arriba="15">
                        <LabelForm>Importacion:</LabelForm>
                    </ContainerCol>
                    <ContainerCol className='col-sm-6' margen_arriba="15">
                        <ReactSelectAsync value={this.state.importacion_sel} func_loadOptions={this.getOptions_Importaciones} func_onChange={(value)=>{this.setState({importacion_sel: value!==null?value:null})}}/>
                    </ContainerCol> 
                </Row>
                <Row>
                    <ContainerCol className='col-sm-2' margen_abajo='4'>
                        <LabelForm>Sin FOB:</LabelForm>
                    </ContainerCol>                
                    <ContainerCol className='col-sm-2' margen_abajo='4'>
                        <LabelForm><input type='checkbox' name='opcion' checked={this.state.opcion==='I'?true:false} onChange={this.changeComponents}/></LabelForm> 
                    </ContainerCol>
                </Row>
                <Row>
                    <ContainerCol className='col-sm-12'>
                        <div className='btn-group pull-right'>
                            <button type='button' className='btn btn-info btn-sm' disabled={this.state.importacion_sel===null?true:false} onClick={()=>{this.impGastoImportacion('PDF')}}><i className="fa fa-print fa-lg" aria-hidden="true"/> Imprimir</button>  
                            <button type="button" className='btn btn-sm'  onClick={this.limpiar}><i className="fa fa-trash-o fa-lg"></i> Limpiar</button>
                        </div>
                    </ContainerCol>
                </Row>
            </CuerpoForm>
            </ContenedorForm>
        )
    }
}

const mapStateToProps = ((state) => {
    return {puntoFacturacionSel: state.ventas.ptoFacturacionSel, 
            fechaProceso: state.sesion.valoresSesionForm.FechaProceso,
            permiso: state.sesion.valoresSesionForm.Permiso,
            usuario: state.sesion.valoresSesionForm.Usuario,
            IdRegAudit: state.sesion.valoresSesionForm.IdRegAudit,}
  });
  
  const mapDispatchToProps = ((dispatch) => {  
    return bindActionCreators({ generar_LogAuditoriaIngresoForm, generar_LogAuditoriaSalidaForm}, dispatch)
  });
  
  export default connect (mapStateToProps, mapDispatchToProps)(FormImpor09);